import script from "./EsWaitingRoomSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./EsWaitingRoomSelector.vue?vue&type=script&setup=true&lang=ts"

import "./EsWaitingRoomSelector.vue?vue&type=style&index=0&id=16c0a8a5&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c0a8a5"]])

export default __exports__